// ============================================================
// 🗄️  STORE GLOBAL - Zustand
// Estado compartilhado entre componentes sem prop-drilling
// ============================================================
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

const useAppStore = create(
  persist(
    (set) => ({
      // ─── Autenticação ───────────────────────────────────────
      usuario: null,
      setUsuario: (usuario) => set({ usuario }),
      clearUsuario: () => set({ usuario: null }),

      // MULTI-TENANT: tenant ativo (preenchido após login)
      tenant:   null,
      tenantId: null,
      setTenant:   (tenant)   => set({ tenant, tenantId: tenant?.id ?? null }),
      clearTenant: ()         => set({ tenant: null, tenantId: null }),

      // ─── Cache de Clientes ──────────────────────────────────
      clientesCache: [],
      setClientesCache: (clientes) => set({ clientesCache: clientes }),

      dadosCarregados: false,
      setDadosCarregados: (v) => set({ dadosCarregados: v }),

      // ─── Notificações ───────────────────────────────────────
      totalNaoLidas: 0,
      setTotalNaoLidas: (n) => set({ totalNaoLidas: n }),

      // ─── Atendente Virtual ──────────────────────────────────
      atendenteAtivo: false,
      setAtendenteAtivo: (v) => set({ atendenteAtivo: v }),

      // ─── UI / Preferências ──────────────────────────────────
      sidebarAberto: false,
      setSidebarAberto: (v) => set({ sidebarAberto: v }),
    }),
    {
      name: 'crm-gas-store',
      storage: createJSONStorage(() => localStorage),
      // Persiste apenas o usuário (o resto é recarregado ao abrir)
      // MULTI-TENANT: persiste tenant junto com o usuário
      partialize: (state) => ({ usuario: state.usuario, tenant: state.tenant, tenantId: state.tenantId }),
    }
  )
);

export default useAppStore;
